import ChangeNameForm from './ChangeNameForm';

export default ChangeNameForm;
